export default __webpack_public_path__ + "static/ua-c4e7e63138feb1f8edc0bbef5e21592f.svg";